import { render, staticRenderFns } from "./AppStoreChannelDetail.vue?vue&type=template&id=44700e26&scoped=true"
import script from "./AppStoreChannelDetail.vue?vue&type=script&lang=js"
export * from "./AppStoreChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./AppStoreChannelDetail.vue?vue&type=style&index=0&id=44700e26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44700e26",
  null
  
)

export default component.exports